import type {components} from '@/lib/api-schema'

type NotificationKind = components['schemas']['NotificationKind']

// Espeja el enum `NotificationKind` del backend, en su orden. ALL_CAPS para que el gate de
// doctrina UI (R3) lo lea como enum fijo y no exija el combobox con búsqueda.
export const NOTIFICATION_KIND_OPTIONS: NotificationKind[] = [
  'added_to_business',
  'arl_report_due',
  'accion_vencida',
  'solicitud_por_vencer',
  'solicitud_asignada',
  'accion_asignada',
  'designacion_vence',
  'cierre_ventana',
  'licencia_vence',
  'licencia_rechazada',
  'bateria_solicitada',
  'matriz_legal_novedad',
  'soporte_por_vencer',
  'descarga_export_lista',
  'descarga_formas_lista',
  'lectura_bateria_lista',
  'incidente_reportado',
  'furat_pendiente',
  'investigacion_vence',
  'territorial_vence',
  'investigacion_asignada',
  'sin_sst_asociado',
  'sst_solicitado_inci',
  'solicitud_inci_resuelta',
  'nightly_resultado',
  'incapacidad_reportada',
  'incapacidad_validada',
  'email_despojado_por_duplicado',
  'factura_emitida',
  'factura_vencida',
  'plan_degradado',
  'pago_confirmado',
  'partner_aprobo',
  'partner_rechazo',
  'partner_banda_upgrade',
  'registro_bloqueado',
  // PQ-1: existen y aún no disparan; se listan para que ninguno aparezca en crudo.
  'catalogo_perfiles_actualizado',
  'soporte_sugerido_llego',
  'requisito_por_vencer',
  'requisito_vencido',
  'matriz_cambio_afecta_perfil',
  'carpeta_visita_lista',
  'choque_restriccion_detectado',
  'solicitud_ips_sin_respuesta',
  'solicitud_ips_plazo_largo',
  'concepto_recibido',
  'respuesta_sin_identificar',
  'documento_retenido',
  'cuarentena_por_suprimir',
  'restriccion_por_vencer',
  'licencia_ips_por_vencer',
  'cambio_ocupacion_sugerido',
  'identidad_por_verificar',
  'identidad_verificada',
  'identidad_no_verificada',
]
